// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const addFriend = createAsyncThunk(
	"user-profile/add-friend",
	createApiCall(async ({ userId }, client) => {
		const response = await client.put(`/friend?id=${userId}`);

		return {
			...response.data,
			counters: response.counters,
		};
	})
);

// ############################################################
